import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Schema from '../components/Schema';

const categories = [
  'Solar Industry',
  'Spill Control & Remediation',
  'Glass Surfaces Cleaning & Protection',
  'Vehicles Wash',
  'Heavy Cleaning & Degreasing',
];

// Mock product data
const products = {
  'Solar Industry': [
      {
          name: 'Solar Wash Protect',
          desc: ' 2 in 1 product for cleaning and antistatic protection, developed and certified for photovoltaic panels. ',
          image: 'https://images.prismic.io/chemitek-website/Z1_-m5bqstJ98iYe_SWP.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/e96f5a57-90bf-463d-ad96-a23b42c54065_MKT.003.04.00.EN+ChemiTek+-+Solar+Wash+Protect+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet SWP',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/e96f5a57-90bf-463d-ad96-a23b42c54065_MKT.003.04.00.EN+ChemiTek+-+Solar+Wash+Protect+Leaflet.pdf'
            },
            {
              name: 'Leaflet - Solar Range',
              url: ' https://chemitek-website.cdn.prismic.io/chemitek-website/Z6CYwJbqstJ9-J59_Leaflet-SolarRangeEN.pdf'
            },
            {
              name: 'Diagram - use of SWP and ASA',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/Z4VGmpbqstJ99ZJ0_MKT.083.00.00.ENChemiTek-FlyerVennDiagram.pdf'
            },{
              name: 'Chemitek Solar - Presentation',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/Z64sppbqstJ9-l2M_SPWChemiTek-Solarpresentation%5Bshort%5D-1-_compressed.pdf'
            },{
              name: 'Case Study - Honduras',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/632278ee-26a8-4868-b430-4917cf0cef22_Scatec+%28Honduras%29+-+Solar+Wash+Protect+Case+Study.pdf'
            },{
              name: 'Case Study - India',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/d546d558-aacb-450c-92af-f89890f81281_Soleden+Power+%28India%29+-+Solar+Wash+Protect+Case+Study+%282%29.pdf'
            },{
              name: 'Case Study - Malaysia',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/1198bcd1-6035-41dc-811b-5c0d95c38566_TNBES+%28Malaysia%29+-+SWP+Case+Study.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet SWP 50',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlC7SSol0Zci9boF_MKT.013.01.06.ENChemiTek-SWP50TechnicalDatasheet.pdf'
            },
            {
              name: 'Technical Datasheet SWP 300',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlC7pSol0Zci9boS_MKT.014.01.05.ENChemiTek-SWP300TechnicalDatasheet.pdf'
            },
            {
              name: 'Application Methods SWP',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/Zxuo7IF3NbkBYCcZ_ChemiTek-SWP-ApplicationMethods.pdf'
            },
            {
              name: 'Solar Wash Protect RTU',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/55ddadc4-50a9-4c3a-84dc-9340d4badca5_EN-Solar+Wash+Protect+RTU.pdf'
            },{
              name: 'Technical Datasheet SWP RTU',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/b2df88fb-d925-4379-9a99-42f3efb7ce54_MKT.026.01.01.EN+ChemiTek+-+SWP+RTU+Technical+DataSheet.pdf'
            },
          ],
      },
      {
          name: 'Antistatic Solar Armor 2.0',
          desc: 'Easy to apply antistatic coating, developed and certified for photovoltaic solar panels.',
          image: 'https://images.prismic.io/chemitek-website/aCxCmSdWJ-7kSVVy_ASA2.0.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/aCxDKCdWJ-7kSVWV_MKT.095.00.00.ENChemiTek-AntistaticSolarArmor2.0Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet ASA 2.0',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/aCxDKCdWJ-7kSVWV_MKT.095.00.00.ENChemiTek-AntistaticSolarArmor2.0Leaflet.pdf'
            },
            {
              name: 'Diagram - use of SWP and ASA',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/Z4VGmpbqstJ99ZJ0_MKT.083.00.00.ENChemiTek-FlyerVennDiagram.pdf'
            },
            {
              name: 'Case Study - Israel',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/e4dde795-022b-4c75-9d9a-3a302d8b6085_Chemitek+Solar+-+Case+Study+-+CRA%2BASA+-+Girasol+%28Israel%29.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/aCxDyCdWJ-7kSVXA_MKT.091.00.00.ENChemiTek-ASA2.0TechnicalDatasheet.pdf'
            },
            {
              name: 'User Guide',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/aCxEvSdWJ-7kSVYI_ChemiTek-ASA2.0-UserGuide.pdf'
            },
          ],
      },{
          name: 'D-Solar Defendor',
          desc: 'Easy to apply hydrophobic coating certified for solar panels – keeps the panel cleaner and easier to clean. ',
          image: 'https://images.prismic.io/chemitek-website/Z1_-c5bqstJ98iX__DSD.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/6df76a9d-7d0a-401b-bb54-f410ee6a0b78_MKT.038.03.00.EN+ChemiTek+-+D-Solar+Defendor+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/6df76a9d-7d0a-401b-bb54-f410ee6a0b78_MKT.038.03.00.EN+ChemiTek+-+D-Solar+Defendor+Leaflet.pdf'
            },
            {
              name: 'Case Study: Case study (Vietnam)',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/d97f98f6-c301-4688-bb37-5d2635c439b3_D-Solar+Defendor+Case+Study+-+BIM+AC+Renewables+%28Vietname%291.pdf'
            },
            {
              name: 'Case Study: Case study (Chile)',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/e7eac453-0823-4086-878f-31180bd87158_D-Solar+Defendor+Case+Study+-+Santiago+Solar+Plant+%28Chile%291.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlDAbSol0Zci9bqH_MKT.023.01.05.ENChemiTek-DSDTechnicalDataSheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupMIF3NbkBYCc3_ChemiTek-DSD-ApplicationMethods.pdf'
            },
          ],
      },{
          name: 'Industrial Glass Protect',
          desc: 'Long-lasting hydrophobic coating certified for solar panels. ',
          image: 'https://images.prismic.io/chemitek-website/Z1_-gpbqstJ98iYO_IGP.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/5acbb2d4-74d9-43c7-9c24-1ed31ee9ca8e_MKT.058.02.00.EN+ChemiTek+-+Leaflet+Industrial+Glass+Protect.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/5acbb2d4-74d9-43c7-9c24-1ed31ee9ca8e_MKT.058.02.00.EN+ChemiTek+-+Leaflet+Industrial+Glass+Protect.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlDBniol0Zci9bqs_MKT.015.01.04.ENChemiTek-IGPTechnicalDatasheet.pdf'
            },
          ],
      },{
          name: 'Cement Removal Agent',
          desc: 'Biodegradable concentrated removal agent for cement dust, stone dust, gypsum and other alkali contaminants. ',
          image: 'https://images.prismic.io/chemitek-website/ZzxnkK8jQArT1BRL_4.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/da4db1e5-de95-4393-9c54-70f577ca25f5_MKT.046.03.00.EN+ChemiTek+-+Leaflet+Cement+Removal+Agent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/da4db1e5-de95-4393-9c54-70f577ca25f5_MKT.046.03.00.EN+ChemiTek+-+Leaflet+Cement+Removal+Agent.pdf'
            },
            {
              name: 'Case Study: Case study(Dubai) ',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ac8ee49f-25ac-4d9d-8cb9-335272295ac5_Chemitek+Solar+-+Case+Study+CRA+in+Dubai.pdf'
            },
            {
              name: 'Case Study: Case study(Chile)',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/503ac0d7-897d-4dde-bb6e-472bb70ab4b6_ChemiTek+Solar+-+Case+Study+-+CRA+and+ASA+-+Ecomundo+%28Chile%29.pdf'
            },{
              name: 'Case Study: Case study(Israel)',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ffe65517-0779-4f72-b2ee-b2d870650642_Case+Study+CRA%2BASA_Girasol+%28Israel%29.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlDCSSol0Zci9bq-_MKT.042.01.03.ENChemiTek-CRATechnicalDatasheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupAoF3NbkBYCcs_ChemiTek-CRA-ApplicationMethods.pdf'
            },
          ],
      },{
          name: 'Lichen Removal Agent',
          desc: 'Biodegradable concentrated removal agent for lichens, fungi and moss. ',
          image: 'https://images.prismic.io/chemitek-website/Zzxnia8jQArT1BRH_2.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/0d74eed4-e2c3-41c0-bdaf-3d371a0b2148_MKT.047.03.00.EN+ChemiTek+-+Leaflet+Lichen+Removal+Agent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/0d74eed4-e2c3-41c0-bdaf-3d371a0b2148_MKT.047.03.00.EN+ChemiTek+-+Leaflet+Lichen+Removal+Agent.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: ' https://chemitek-website.cdn.prismic.io/chemitek-website/ZlDDASol0Zci9brX_MKT.044.01.03.ENChemiTek-LRATechnicalDatasheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupDIF3NbkBYCct_ChemiTek-LRA-ApplicationMethods.pdf'
            },
          ],
      },{
          name: ' Metal Oxides Removal Agent',
          desc: 'Biodegradable concentrated removal agent for metal oxides residues',
          image: 'https://images.prismic.io/chemitek-website/Z1_-j5bqstJ98iYY_MRA.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZfCBpUmNsf2sHhw0_MKT.076.00.01.ENChemiTek-LeafletMetalOxidesRemovalAgent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZfCBpUmNsf2sHhw0_MKT.076.00.01.ENChemiTek-LeafletMetalOxidesRemovalAgent.pdf'
            },
          ],
            technicalSheets: [
              {
                name: 'Technical Datasheet',
                url: ' https://chemitek-website.cdn.prismic.io/chemitek-website/ZnQsGZm069VX160E_MKT.075.00.01.ENChemiTek-MRATechnicaldatasheet.pdf'
              },
              {
                name: 'Application Methods',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupOYF3NbkBYCdA_ChemiTek-MRA-ApplicationMethods.pdf'
              },
            ],
      },{
          name: ' Paint Removal Agent',
          desc: 'Biodegradable concentrated removal agent for water and solvent based paint residues.',
          image: 'https://images.prismic.io/chemitek-website/Zzxnk68jQArT1BRM_5.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/2d3d8ef8-86ae-4bd6-9f9c-79dbf8a7d6e3_MKT.065.00.00.EN+ChemiTek+-+Leaflet+Paint+Removal+Agent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/2d3d8ef8-86ae-4bd6-9f9c-79dbf8a7d6e3_MKT.065.00.00.EN+ChemiTek+-+Leaflet+Paint+Removal+Agent.pdf'
            },                
          ],
            technicalSheets: [
              {
                name: 'Technical Datasheet',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZnRJIJm069VX17Ob_MKT.061.00.01.ENChemiTek-PRATechnicalDatasheet.pdf'
              },
              {
                name: 'Application Methods',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupFYF3NbkBYCcv_ChemiTek-PRA-ApplicationMethods.pdf'
              },
            ],
      },{
          name: ' Water Softening Agent ',
          desc: ' Biodegradable treatment for hard and very hard water. Avoids limestone stains on the modules.',
          image: 'https://images.prismic.io/chemitek-website/Zzxnja8jQArT1BRJ_3.png?auto=format,compress',
          leaflet: 'https://images.prismic.io/chemitek-website/Zqeyvh5LeNNTxkfS_Flyers.png?auto=format,compress?auto=compress,format',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://images.prismic.io/chemitek-website/Zqeyvh5LeNNTxkfS_Flyers.png?auto=format,compress?auto=compress,format'
            },
          ],
            technicalSheets: [
              {
                name: 'Technical Datasheet',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZnRaaJm069VX17Zu_MKT.041.01.04.ENChemiTek-WSATechnicalDatasheet.pdf'
              },
              {
                name: 'Application Methods',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupHYF3NbkBYCcx_ChemiTek-WSA-ApplicationMethods.pdf'
              },
            ],
      },{
          name: ' Mirtek ',
          desc: ' - Easy-to-apply concentrated antistatic coating, specially developed for CSP plants.',
          image: 'https://images.prismic.io/chemitek-website/Z1_-i5bqstJ98iYW_Mirtek.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/eec06aee-2002-4b2e-8d80-77a127c77a43_MKT.043.01.00.EN+ChemiTek+-+Mirtek+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/eec06aee-2002-4b2e-8d80-77a127c77a43_MKT.043.01.00.EN+ChemiTek+-+Mirtek+Leaflet.pdf'
            },
          ],
            technicalSheets: [
              {
                name: 'Technical Datasheet',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/abfaf8d7-f8c4-4a57-a138-0c15c3b6ca97_MKT.017.01.03.EN+ChemiTek+-+MTK+Technical+Datasheet.pdf'
              },
              {
                name: 'Application Methods',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupJoF3NbkBYCc2_ChemiTek-Mirtek-ApplicationMethods.pdf'
              },
            ],
        },{
            name: ' Solar Wash Protect RTU  ',
            desc: '  2 in 1 product to clean organic dirt from your solar panels and to protect from the adherence of dirt.',
            image: 'https://images.prismic.io/chemitek-website/Z1_-lpbqstJ98iYd_SWPRTU.png?auto=format,compress',
            leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/22a00431-54b8-4dc6-837e-e624b3ea7368_MKT.064.00.00.EN+ChemiTek+-+Leaflet+SWP+RTU.pdf',
            price: 'LKR 19,000/=',
            brochures: [
              {
                name: 'Leaflet',
                url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/22a00431-54b8-4dc6-837e-e624b3ea7368_MKT.064.00.00.EN+ChemiTek+-+Leaflet+SWP+RTU.pdf'
              },
            ],
              technicalSheets: [
                {
                  name: 'Technical Datasheet',
                  url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/d2b80662-f24a-4261-863e-6c7a2543594e_MKT.026.01.01.EN+ChemiTek+-+SWP+RTU+Technical+DataSheet.pdf'
                },
              ],
          },            
      ],
  'Spill Control & Remediation': [
      {
          name: 'Super Degreasing Mono ',
          desc: ' Degreaser/descaling agent for oils, fuels, grease, and coal deposits and other hard to remove stains.',
          image: 'https://images.prismic.io/chemitek-website/45eb059c-f9f0-4724-8e8c-4b569406df92_SuperDegreasingMono_4.png?auto=compress,format',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/96fd9cf9-0ccd-4762-a065-2a32c5f6afc3_MKT.012.01.00.EN+ChemiTek+-+Super+Degreasing+Mono+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaftlet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/96fd9cf9-0ccd-4762-a065-2a32c5f6afc3_MKT.012.01.00.EN+ChemiTek+-+Super+Degreasing+Mono+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/b56c55ca-7ebb-4ef9-803b-37f5a91ba1a9_MKT.025.01.03.EN+ChemiTek+-+SDM+Technical+Datasheet.pdf'
            },
          ],
      },
      {
          name: 'Biodegrease Pro ',
          desc: 'Degreaser/Descaler for delicate surfaces with biodegradable surfactants.',
          image: 'https://images.prismic.io/chemitek-website/abd661f7-ba7a-41fb-bea7-5fd2bdeb4bcd_BiodegreasePro_4.png?auto=compress,format',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/5c79a133-4cdf-4b75-94bb-071468cdc096_MKT.008.01.00.EN+ChemiTek+-+Biodegrease+Pro+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/5c79a133-4cdf-4b75-94bb-071468cdc096_MKT.008.01.00.EN+ChemiTek+-+Biodegrease+Pro+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/e249c287-1272-4240-b112-38116c718850_MKT.019.01.02.EN+ChemiTek+-+BP+Technical+Datasheet.pdf'
            },
          ],
      },{
          name: 'Spill Control Pro ',
          desc: 'Fast-acting hydrocarbon dispersant for cleaning up residues of oils, fuels, and other spills from heavy industries.',
          image: 'https://images.prismic.io/chemitek-website/245bd887-66bb-40c2-b8f7-8ef40b7e7f69_SpillControlPro_3.png?auto=compress,format',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/3ddea1df-2471-4694-82e6-dca566b6b15e_MKT.009.01.00.EN+ChemiTek+-+Spill+Control+Pro+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaftlet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/3ddea1df-2471-4694-82e6-dca566b6b15e_MKT.009.01.00.EN+ChemiTek+-+Spill+Control+Pro+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/29948208-72a7-4064-b065-4ff3b94d1997_MKT.020.01.03.EN+ChemiTek+-+SCP+Technical+DataSheet.pdf'
            },
          ],
      },
  ],
  'Glass Surfaces Cleaning & Protection': [
      {
          name: 'Cement Removal Agent',
          desc: ' Biodegradable concentrated removal agent for cement dust, stone dust, gypsum and other alkali contaminants',
          image: 'https://images.prismic.io/chemitek-website/ZzxnkK8jQArT1BRL_4.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/da4db1e5-de95-4393-9c54-70f577ca25f5_MKT.046.03.00.EN+ChemiTek+-+Leaflet+Cement+Removal+Agent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/da4db1e5-de95-4393-9c54-70f577ca25f5_MKT.046.03.00.EN+ChemiTek+-+Leaflet+Cement+Removal+Agent.pdf'
            },
            {
              name: 'Case Study: Case study(Dubai)',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ac8ee49f-25ac-4d9d-8cb9-335272295ac5_Chemitek+Solar+-+Case+Study+CRA+in+Dubai.pdf'
            },{
              name: 'Case Study: Case study(Chile)',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/503ac0d7-897d-4dde-bb6e-472bb70ab4b6_ChemiTek+Solar+-+Case+Study+-+CRA+and+ASA+-+Ecomundo+%28Chile%29.pdf'
            },{
              name: 'Case Study: Case study(Israel)',
              url: ' https://chemitek-website.cdn.prismic.io/chemitek-website/ffe65517-0779-4f72-b2ee-b2d870650642_Case+Study+CRA%2BASA_Girasol+%28Israel%29.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlDCSSol0Zci9bq-_MKT.042.01.03.ENChemiTek-CRATechnicalDatasheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupAoF3NbkBYCcs_ChemiTek-CRA-ApplicationMethods.pdf'
            },
          ],
      },{
          name: 'Lichen Removal Agent ',
          desc: 'Biodegradable concentrated removal agent for lichens, fungi and moss.',
          image: 'https://images.prismic.io/chemitek-website/Zzxnia8jQArT1BRH_2.png?auto=format,compress',
          leaflet: ' https://chemitek-website.cdn.prismic.io/chemitek-website/0d74eed4-e2c3-41c0-bdaf-3d371a0b2148_MKT.047.03.00.EN+ChemiTek+-+Leaflet+Lichen+Removal+Agent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/0d74eed4-e2c3-41c0-bdaf-3d371a0b2148_MKT.047.03.00.EN+ChemiTek+-+Leaflet+Lichen+Removal+Agent.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZlDDASol0Zci9brX_MKT.044.01.03.ENChemiTek-LRATechnicalDatasheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupDIF3NbkBYCct_ChemiTek-LRA-ApplicationMethods.pdf'
            },
          ],
      },{
          name: 'Metal Oxides Removal Agent ',
          desc: ' Biodegradable concentrated removal agent for metal oxides residues',
          image: 'https://images.prismic.io/chemitek-website/Z1_-j5bqstJ98iYY_MRA.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZfCBpUmNsf2sHhw0_MKT.076.00.01.ENChemiTek-LeafletMetalOxidesRemovalAgent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZfCBpUmNsf2sHhw0_MKT.076.00.01.ENChemiTek-LeafletMetalOxidesRemovalAgent.pdf'
            },
          ],
          technicalSheets: [
            {
              name: ' Technical Datasheet',
              url: ' https://chemitek-website.cdn.prismic.io/chemitek-website/ZnQsGZm069VX160E_MKT.075.00.01.ENChemiTek-MRATechnicaldatasheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupOYF3NbkBYCdA_ChemiTek-MRA-ApplicationMethods.pdf'
            },
          ],
      },{
          name: 'Paint Removal Agent ',
          desc: ' Biodegradable concentrated removal agent for water and solvent based paint residues. ',
          image: 'https://images.prismic.io/chemitek-website/Zzxnk68jQArT1BRM_5.png?auto=format,compress',
          leaflet: ' https://chemitek-website.cdn.prismic.io/chemitek-website/2d3d8ef8-86ae-4bd6-9f9c-79dbf8a7d6e3_MKT.065.00.00.EN+ChemiTek+-+Leaflet+Paint+Removal+Agent.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/2d3d8ef8-86ae-4bd6-9f9c-79dbf8a7d6e3_MKT.065.00.00.EN+ChemiTek+-+Leaflet+Paint+Removal+Agent.pdf'
            },
          ],
          technicalSheets: [
            {
              name: ' Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZnRJIJm069VX17Ob_MKT.061.00.01.ENChemiTek-PRATechnicalDatasheet.pdf'
            },
            {
              name: 'Application Methods',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/ZxupFYF3NbkBYCcv_ChemiTek-PRA-ApplicationMethods.pdf'
            },
          ],
      },{
          name: 'IGP Kit ',
          desc: ' Complete DIY kit for the homeowner that wants its glass protected and easy to clean.',
          image: 'https://images.prismic.io/chemitek-website/Zzxyvq8jQArT1BdZ_Bid%C3%B5essite.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/c9b040d7-2109-4b97-a238-e1610369ec66_MKT.005.01.01.EN+ChemiTek+-+IGP+Kit+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/c9b040d7-2109-4b97-a238-e1610369ec66_MKT.005.01.01.EN+ChemiTek+-+IGP+Kit+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Instructions Manual, FAQs & Warranty',
              url: ' https://chemitek-website.cdn.prismic.io/chemitek-website/ce09a449-59d1-4483-95a9-e0469d7b73c8_MKT.060.00.00.EN+ChemiTek+-+IGP+Kit+-+Instructions+Manual_+FAQs+and+Warranty.pdf'
            },
          ],
      },{
          name: ' IGP PRO ',
          desc: ' Invisible, hydrophobic, oleophobic, and long-lasting treatment for glass, tiles, joints, and metals ',
          image: 'https://images.prismic.io/chemitek-website/Zzxnmq8jQArT1BRR_7.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/763cda0f-f177-4a68-b68c-2a882ea1a493_MKT.004.01.00.EN+ChemiTek+-+Industrial+Glass+Protect+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/763cda0f-f177-4a68-b68c-2a882ea1a493_MKT.004.01.00.EN+ChemiTek+-+Industrial+Glass+Protect+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/7bc60075-f5b2-44a4-8395-b2245da3bee2_MKT.015.01.04.EN+ChemiTek+-+IGP+Technical+Datasheet.pdf'
            },
          ],
      },{
          name: 'Glass Clean Protect ',
          desc: ' Product for professional use for cleaning and antistatic protection for glass – repels dust and makes cleaning easier.',
          image: 'https://images.prismic.io/chemitek-website/Zzxnl68jQArT1BRP_6.png?auto=format,compress',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/76c2888f-5cf4-4b70-aad1-b303505cd417_MKT.005.01.00.EN+ChemiTek+-+Glass+Clean+Protect+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/76c2888f-5cf4-4b70-aad1-b303505cd417_MKT.005.01.00.EN+ChemiTek+-+Glass+Clean+Protect+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/2c900efd-cba8-4c50-9e8e-3c8e06bbc21f_MKT.016.01.03.EN+ChemiTek+-+GCP+Technical+Datasheet.pdf'
            },
          ],
      },
  ],
  'Vehicles Wash': [
      {
          name: 'Truck Wash Pro',
          desc: 'Alkaline product for professional use, for pre-washing of trucks, buses, heavy machinery and trains.',
          image: 'https://images.prismic.io/chemitek-website/013d425a-3b6b-4614-91d5-cc76411f26b7_TruckWashPro_3.png?auto=compress,format',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/cf273d9e-9cf6-4527-9e0a-59232b3d44e7_MKT.010.01.00.EN+ChemiTek+-+Truck+Wash+Pro+Leaflet.pdf',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/cf273d9e-9cf6-4527-9e0a-59232b3d44e7_MKT.010.01.00.EN+ChemiTek+-+Truck+Wash+Pro+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/03d6e2c5-2d38-4ff8-b9cf-3bad8103c309_MKT.021.01.02.EN+ChemiTek+-+TWP+Technical+Datasheet.pdf'
            },
          ],
      },
  ],
  'Heavy Cleaning & Degreasing': [
      {
          name: 'Super Degreasing Mono ',
          desc: ' Degreaser/descaling agent for oils, fuels, grease, and coal deposits and other hard to remove stains. ',
          image: 'https://images.prismic.io/chemitek-website/45eb059c-f9f0-4724-8e8c-4b569406df92_SuperDegreasingMono_4.png?auto=compress,format',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/96fd9cf9-0ccd-4762-a065-2a32c5f6afc3_MKT.012.01.00.EN+ChemiTek+-+Super+Degreasing+Mono+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaftlet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/96fd9cf9-0ccd-4762-a065-2a32c5f6afc3_MKT.012.01.00.EN+ChemiTek+-+Super+Degreasing+Mono+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/b56c55ca-7ebb-4ef9-803b-37f5a91ba1a9_MKT.025.01.03.EN+ChemiTek+-+SDM+Technical+Datasheet.pdf'
            },
          ],
      },{
          name: 'Biodegrease Pro ',
          desc: 'Degreaser/Descaler for delicate surfaces with biodegradable surfactants.',
          image: 'https://images.prismic.io/chemitek-website/abd661f7-ba7a-41fb-bea7-5fd2bdeb4bcd_BiodegreasePro_4.png?auto=compress,format',
          leaflet: 'https://chemitek-website.cdn.prismic.io/chemitek-website/5c79a133-4cdf-4b75-94bb-071468cdc096_MKT.008.01.00.EN+ChemiTek+-+Biodegrease+Pro+Leaflet.pdf',
          price: 'LKR 19,000/=',
          brochures: [
            {
              name: 'Leaflet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/5c79a133-4cdf-4b75-94bb-071468cdc096_MKT.008.01.00.EN+ChemiTek+-+Biodegrease+Pro+Leaflet.pdf'
            },
          ],
          technicalSheets: [
            {
              name: 'Technical Datasheet',
              url: 'https://chemitek-website.cdn.prismic.io/chemitek-website/e249c287-1272-4240-b112-38116c718850_MKT.019.01.02.EN+ChemiTek+-+BP+Technical+Datasheet.pdf'
            },
          ],
      },
  ],
};
  
const SolaCleaningChemicals = () => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0])
  const [selectedProduct, setSelectedProduct] = useState(null)

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    const data = {
      name: form.name.value,
      product: form.product.value,
      quantity: form.quantity.value,
      email: form.email.value,
      address: form.address.value,
      phone: form.phone.value,
    }

    const msg = `Buying Request:
    Name: ${data.name}
    Product: ${data.product}
    Quantity: ${data.quantity}
    Email: ${data.email}
    Address: ${data.address}
    Phone: ${data.phone}`

    const encodedMsg = encodeURIComponent(msg)
    window.open(`https://wa.me/94777129021?text=${encodedMsg}`, '_blank')

    setSelectedProduct(null)
  }

  const [searchQuery, setSearchQuery] = useState("");


  return (
    <div className="min-h-screen px-4 sm:px-8 py-16 bg-gray-100">
    <Schema />
  <h1
          className="text-6xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl 2xl:text-8xl font-bold text-black text-center mb-10"
        >
    ChemiTek Products
  </h1>

  {/* Category Buttons */}
  <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-16">
    {categories.map((cat) => (
      <button
        key={cat}
        onClick={() => setSelectedCategory(cat)}
        className={`px-6 py-2 rounded-xl text-sm font-semibold transition-colors duration-300 ${
          selectedCategory === cat
            ? 'bg-black text-white shadow-lg'
            : 'bg-white text-black border border-gray-300 hover:bg-gray-100'
        }`}
      >
        {cat}
      </button>
    ))}
  </div>

  <div className="flex justify-center mb-12">
  <input
    type="text"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    placeholder="⌕ Search products..."
    className="w-full sm:w-1/3 px-5 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition"
  />
</div>


  {/* Product Grid */}
<div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 px-4">
{products[selectedCategory]
  .filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    product.desc.toLowerCase().includes(searchQuery.toLowerCase())
  )
  .map((product, index) => (

    <div
      key={index}
      className="flex flex-col md:flex-row bg-white rounded-3xl overflow-hidden transition-transform duration-300 ease-in-out hover:scale-[1.02]"
    >

      {/* Image */}
      <div className="md:w-1/2 w-full bg-gray-50 flex justify-center items-center p-6">
        <img
          src={product.image}
          alt={product.name}
          className="w-full max-h-80 object-contain"
        />
      </div>

      {/* Details */}
      <div className="md:w-1/2 w-full p-6 flex flex-col justify-between">
        <div>
          <h3 className="text-3xl font-semibold text-black mb-3">{product.name}</h3>
          <p className="text-gray-600 text-base leading-relaxed">{product.desc}</p>
        </div>

        <div className="flex flex-row flex-wrap gap-3 mt-3">
  <button
    onClick={() => navigate('/buy-chemi-tek', { state: { product } })}
    className="px-4 py-1.5 rounded-md bg-black text-white text-sm font-medium hover:bg-gray-900 transition"
  >
    Buy Now
  </button>
  <button
    onClick={() => window.open(product.leaflet, '_blank')}
    className="px-4 py-1.5 rounded-md border border-black text-black text-sm hover:bg-gray-100 transition"
  >
    View Product →
  </button>
</div>


      </div>
    </div>
  ))}
</div>




  {/* Modal Form */}
  {selectedProduct && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center px-4">
      <div className="bg-white max-w-md w-full p-6 rounded-2xl shadow-xl space-y-4 overflow-y-auto max-h-[90vh]">
        <h3 className="text-xl font-bold text-center text-black">Buying Request</h3>
        <form onSubmit={handleSubmit} className="space-y-3">
          <input name="name" placeholder="Your Full Name" required className="w-full p-3 border rounded-md" />
          <input name="product" value={selectedProduct.name} readOnly className="w-full p-3 bg-gray-100 border rounded-md" />
          <input name="quantity" placeholder="Quantity" required className="w-full p-3 border rounded-md" />
          <input name="email" type="email" placeholder="Email" required className="w-full p-3 border rounded-md" />
          <input name="address" placeholder="Address" required className="w-full p-3 border rounded-md" />
          <input name="phone" placeholder="Phone Number" required className="w-full p-3 border rounded-md" />
          <p className="text-xs text-gray-500">* We'll contact you via WhatsApp after you submit.</p>
          <div className="flex justify-between gap-4 pt-2">
            <button type="button" onClick={() => setSelectedProduct(null)} className="flex-1 py-2 bg-gray-300 rounded hover:bg-gray-400">
              Cancel
            </button>
            <button type="submit" className="flex-1 py-2 bg-green-600 text-white rounded hover:bg-green-700">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )}
</div>

  )
}

export default SolaCleaningChemicals;
